import styled from 'styled-components';

export const TextAlignRight = styled.div`
  text-align: right;
`;
